import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import AuthLayout from './AuthLayout';

export default function AuthConflict() {
    const { logout } = useAuth();

    return (
        <AuthLayout>
            <div className="m-auto w-full max-w-lg text-center">
                <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground">
                    Não foi possível acessar sua conta
                </h2>

                <p className="mb-8 leading-relaxed text-muted-foreground">
                    Encontramos um conflito ao vincular sua conta autenticada ao seu cadastro da
                    LaudoPsi. Entre em contato com o suporte para concluir o acesso com segurança.
                </p>

                <Button variant="outline" size="xl" className="w-full" onClick={() => logout()}>
                    Voltar para o login
                </Button>
            </div>
        </AuthLayout>
    );
}
